import React, { useCallback, useEffect, useState } from 'react';
import { Alert, AlertColor, Snackbar, Typography } from '@mui/material';
import classNames from 'classnames';
import { useSnackbarStyles } from 'modules/common/hooks/useSnackbarStyles';

type ToastSnackBarProps = {
  show: boolean;
  category: AlertColor | undefined;
  message: string | undefined;
  onClose?: () => void;
  pinned?: boolean;
  duration?: number | null;
};

export const ToastSnackBar: React.FC<ToastSnackBarProps> = ({
  show,
  category,
  message,
  onClose,
  duration = 3000
}: ToastSnackBarProps) => {
  const classes = useSnackbarStyles({
    category
  });
  const [open, setOpen] = useState<boolean>();
  useEffect(() => {
    show ? setOpen(true) : setOpen(false);
  }, [show]);
  const handleClose = useCallback(() => {
    setOpen(false);
    if (onClose) onClose();
  }, [onClose]);

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
      data-testid="save-snackbar"
      onClose={handleClose}
      autoHideDuration={duration}
      className={classes.snackBar}
    >
      <Alert
        data-testid="save-alert"
        severity={category}
        variant="filled"
        className={classNames(classes.item, classes.severity)}
      >
        <Typography variant="body1">{message}</Typography>
      </Alert>
    </Snackbar>
  );
};
